import jsCookie from '@s-ui/js/lib/cookie'

export const readBlockedUsers = ({cookieKey}) => {
  try {
    const blockedUsers = JSON.parse(jsCookie.get(cookieKey) ?? '[]')

    return Array.isArray(blockedUsers) ? blockedUsers : []
  } catch {
    return []
  }
}

export const removeBlockedUser = ({cookieKey, userId}) =>
  jsCookie.set(
    cookieKey,
    JSON.stringify(readBlockedUsers({cookieKey}).filter(blockedUser => String(blockedUser) !== String(userId)))
  )
